import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ImageService } from '../../../../../services/image/image.service';
import { FormatService } from '../../../../../common/format/format.service';
import { ApplicationStatusEnum, BriefApplicationResponseDto, SocialChannelEnum } from '../../../../../common/general-types/briefs.dto';
import { FeedPostedSubPostComponent } from '../feed-posted-sub-post/feed-posted-sub-post.component';

@Component({
  selector: 'brief-feed-posted',
  standalone: true,
  imports: [FeedPostedSubPostComponent],
  templateUrl: './feed-posted.component.html',
  styleUrl: './feed-posted.component.css'
})
export class FeedPostedComponent {

  SocialChannelEnum = SocialChannelEnum;

  @Input('activity') activity!: {
    applicationStatus: ApplicationStatusEnum;
    date: Date;
    briefApplications: any[];
  };
  @Input('socialChannel') socialChannel: SocialChannelEnum | 'UGC' = 'UGC';
  @Output() viewPostedOut = new EventEmitter<void>();

  /** Services */
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  /** Services END */

  viewPosted() {
    console.log('viewPosted()');
    if (this.activity.briefApplications.length > 0) {
      this.viewPostedOut.emit();
    }
  }
}
